import { ResumeDto, UpdateResumeDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import debounce from "lodash.debounce";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";
import { trackEvent } from "@/client/utils/analytics";

let dl_id = sessionStorage.getItem("token");

function removeNullsAndReplaceWithEmpty(obj: any) {
  for (var key in obj) {
    if (obj[key] === null) {
      obj[key] = "";
    } else if (typeof obj[key] === "object") {
      // Recursively call the function for nested objects
      obj[key] = removeNullsAndReplaceWithEmpty(obj[key]);
    }
  }
  return obj;
}
export const updateResume = async (data: any) => {
  let dl_id = sessionStorage.getItem("token");
  data["token"] = dl_id;
  if (data.data.basics.picture.base64_url) {
    delete data.data.basics.picture.base64_url;
  }
  if (data.data.basics.picture.url === "") {
    document.getElementsByClassName("dropbtn")[0].getElementsByTagName("img")[0].src =
      "/icon/avatar.png";
  } else {
    document.getElementsByClassName("dropbtn")[0].getElementsByTagName("img")[0].src =
      data.data.basics.picture.url;
  }
  data = removeNullsAndReplaceWithEmpty(data);
  const userId = useAuthStore.getState().user?.id;
  try {
    const response = await axios.patch<ResumeDto, AxiosResponse<ResumeDto>, UpdateResumeDto>(
      `/resume/update`,
      data,
    );

    queryClient.setQueryData<ResumeDto>(["resume", { id: response.data.id }], response.data);

    queryClient.setQueryData<ResumeDto[]>(["resumes"], (cache) => {
      if (!cache) return [response.data];
      return cache.map((resume) => {
        if (resume.id === response.data.id) return response.data;
        return resume;
      });
    });

    trackEvent({
      userType: "youth",
      apiName: "updateResume",
      userId,
      success: true,
      resourceId: response.data.id,
    });
    return response.data;
  } catch (error) {
    trackEvent({ userType: "youth", apiName: "updateResume", userId, success: false });
    throw error;
  }
};

export const debouncedUpdateResume = debounce(updateResume, 500);

export const useUpdateResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: updateResumeFn,
  } = useMutation({
    mutationFn: updateResume,
  });

  return { updateResume: updateResumeFn, loading, error };
};
